import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import E50Description from "@e50/components/E50Description";
import E50Footer from "@e50/components/E50FooterComponents/E50Footer";
import E50NominationsDescription from "@e50/components/E50NominationsDescription";
import E50OrganiserDetails from "@e50/components/E50OrganiserDetails";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import LandingPageArticle from "@events-awards/components/LandingPageArticle";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";

/**
 * Component to render E50 page
 */
const EventsAwardsE50PageContent = ({
  articleProps,
  gaProps,
}: EventsAwardsLandingPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div
      className="w-full"
      data-testid="events-awards-e50-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.E50} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <LandingPageArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <E50Description />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <E50NominationsDescription />
        </Container>
      </div>

      <E50OrganiserDetails />

      <E50Footer />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsE50PageContent;
